import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { grayColor } from "../../../../../assets/jss/material-dashboard-pro-react";

const columnOrganizationToggleStyle = (clientColor) => ({
  toggleContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 12px",
    backgroundColor: grayColor[13],
    borderRadius: "4px",
    fontSize: "11px",
    flexShrink: 0,
    border: `1px solid ${grayColor[10]}`,
  },
  toggleSwitch: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer",
  },
  toggleLabel: {
    fontSize: "11px",
    color: grayColor[1],
    fontWeight: "500",
    whiteSpace: "nowrap",
  },
  switchContainer: {
    position: "relative",
    width: "40px",
    height: "20px",
    backgroundColor: grayColor[8],
    borderRadius: "10px",
    transition: "background-color 0.3s ease",
    cursor: "pointer",
    "&.active": {
      backgroundColor: clientColor ? `${clientColor}CC` : "#4CAF50", // 80% opacity for subtle variation
    },
  },
  switchSlider: {
    position: "absolute",
    top: "2px",
    left: "2px",
    width: "16px",
    height: "16px",
    backgroundColor: "white",
    borderRadius: "50%",
    transition: "transform 0.3s ease",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    "&.active": {
      transform: "translateX(20px)",
    },
  },
  hiddenInput: {
    position: "absolute",
    opacity: 0,
    width: 0,
    height: 0,
  },
});

const ColumnOrganizationToggle = ({
  columnOrganization,
  onToggleChange,
  clientColor,
}) => {
  const useStyles = makeStyles(() =>
    columnOrganizationToggleStyle(clientColor),
  );
  const classes = useStyles();

  const T_PREFIX = "rgm.cockpit";
  const { t } = useTranslation("translation", { keyPrefix: T_PREFIX });

  const isScenarioFirst = columnOrganization === "scenario-first";

  const handleToggleChange = () => {
    const newOrganization = isScenarioFirst ? "elo-first" : "scenario-first";
    onToggleChange(newOrganization);
  };

  return (
    <div className={classes.toggleContainer}>
      <div className={classes.toggleSwitch} onClick={handleToggleChange}>
        <span className={classes.toggleLabel}>
          {t("comparative.column_organization.scenario_first")}
        </span>
        <div
          className={`${classes.switchContainer} ${isScenarioFirst ? "active" : ""}`}
        >
          <div
            className={`${classes.switchSlider} ${!isScenarioFirst ? "active" : ""}`}
          />
        </div>
        <span className={classes.toggleLabel}>
          {t("comparative.column_organization.scenario_last")}
        </span>
        <input
          type="checkbox"
          className={classes.hiddenInput}
          checked={isScenarioFirst}
          onChange={() => {}} // Handled by onClick
          aria-label={t("comparative.hierarchy.toggle_aria_label")}
        />
      </div>
    </div>
  );
};

ColumnOrganizationToggle.propTypes = {
  columnOrganization: PropTypes.oneOf(["scenario-first", "elo-first"])
    .isRequired,
  onToggleChange: PropTypes.func.isRequired,
  clientColor: PropTypes.string,
};

export default ColumnOrganizationToggle;
